import React from "react";

const UserPermission = ({ color }) => {
  return (
    <svg
      width="342"
      height="385"
      viewBox="0 0 342 385"
      fill="none"
      className="size-5"
      stroke={color || "#1E4387"}
      stroke-width="30"
    >
      <path
        d="M181.667 352.334H39.8427C36.0535 352.34 32.3003 351.597 28.7984 350.149C25.2966 348.702 22.1147 346.576 19.4353 343.896C16.7559 341.217 14.6316 338.036 13.1841 334.535C11.7366 331.033 10.9944 327.279 11 323.49V189.175C11 173.196 23.864 160.334 39.8427 160.334H216.824C232.803 160.334 245.667 173.196 245.667 189.175"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M203 107V85.6667C203 65.8638 195.134 46.8699 181.131 32.8672C167.128 18.8645 148.136 11 128.334 11C108.531 11 89.5391 18.8645 75.5364 32.8672C61.5336 46.8699 53.667 65.8638 53.667 85.6667V149.667"
        stroke-linejoin="round"
      />
      <path
        d="M245.666 373.667C292.795 373.667 331 335.462 331 288.333C331 241.205 292.795 203 245.666 203C198.538 203 160.333 241.205 160.333 288.333C160.333 335.462 198.538 373.667 245.666 373.667Z"
        stroke-linejoin="round"
      />
      <path
        d="M289.016 258.893L236.642 314.275L208.184 287.352"
      />
    </svg>
  );
};

export default UserPermission;
